import { useIndicationModal } from '@hooks/use-indication-modal';
import IndicationModal from '.';

const IndicationModalManager = () => {
  const { isOpen, setIsOpen } = useIndicationModal();

  return <IndicationModal isOpen={isOpen} setIsOpen={setIsOpen} />;
};

export default IndicationModalManager;
